import { Component } from '@angular/core';

@Component({
    selector: 'kh-dialog-header',
    templateUrl: './dialog-header.component.html',
})
export class DialogHeaderComponent { }
